import { observer } from 'mobx-react-lite'
import React from 'react'
import { SearchCurrentFilter } from '@/modules/products/views/ProductListView'
import { Button } from 'antd'
import Image from 'next/image'
import { FilterItemType, FilterMap } from '@/modules/products/viewModels/ProductListViewModel'
import styled from 'styled-components'
import { nanoid } from '@solvook/nanoid'

export interface ProductCurrentFilterTagProps {
	onFilterClick: () => void
	filterItems: FilterMap
	deleteFilterItem: (item: FilterItemType) => void
}

const ProductFilterTagItem: React.FC<{
	item: FilterItemType
	deleteFilterItem: (item: FilterItemType) => void
}> = observer(({ item, deleteFilterItem }) => {
	return (
		<Button
			onClick={() => {
				deleteFilterItem(item)
			}}
			data-idx={item.id}
			key={`filter-item-${item.id}`}>
			{item.label ? item.label : item.value}
			<Image
				src={'/static/assets/icon_close_m.svg'}
				alt={'삭제 아이콘'}
				width={16}
				height={16}
			/>
		</Button>
	)
})

export const ProductCurrentFilterTag = observer<ProductCurrentFilterTagProps>(
	({ onFilterClick, filterItems, deleteFilterItem }) => {
		const items = Object.keys(filterItems).map((key) => {
			return filterItems[key].map((item) => {
				const uid = nanoid()
				return (
					<ProductFilterTagItem
						key={uid}
						item={item}
						deleteFilterItem={deleteFilterItem}
					/>
				)
			})
		})

		return (
			<ProductCurrentFilterTagWrapper>
				<div className="section">
					<SearchCurrentFilter>
						<div className="text w">선택한 필터값</div>
						<div className="text m">
							<Button onClick={onFilterClick}>
								<Image
									src={'/static/assets/icon_filter_m.svg'}
									alt={'필터'}
									width={16}
									height={16}
								/>
								필터
							</Button>
						</div>
						<div className="current-filter-area">{items}</div>
					</SearchCurrentFilter>
				</div>
			</ProductCurrentFilterTagWrapper>
		)
	},
)

export const ProductCurrentFilterTagWrapper = styled.div`
	.search-result-wrapper:has(&) > .section {
		padding-top: 0;

		@media (max-width: 768px) {
			padding-bottom: 0;
		}
	}

	> .section {
		padding-top: 16px;

		@media (max-width: 768px) {
			padding-top: 0;
		}
	}
`
